module.exports = "/_next/static/images/icon-empty-9b10a46c.png";